/* eslint-disable */
import { getLocale, experimentalStaticLocale } from '../runtime.js';

/** @typedef {import('../runtime.js').LocalizedString} LocalizedString */

/** @typedef {{}} Options_Cli_Developer_SelectionInputs */



/**
* | output |
* | --- |
* | "Developer Selection" |
*
* @param {Options_Cli_Developer_SelectionInputs} inputs
* @param {{ locale?: "en" | "fr" | "de" | "it" | "ru" | "es" | "zh-CN" | "ja" | "hi" | "pt-PT" }} options
* @returns {LocalizedString}
*/
export const options_cli_developer_selection = /** @type {((inputs?: Options_Cli_Developer_SelectionInputs, options?: { locale?: "en" | "fr" | "de" | "it" | "ru" | "es" | "zh-CN" | "ja" | "hi" | "pt-PT" }) => LocalizedString) & import('../runtime.js').MessageMetadata<Options_Cli_Developer_SelectionInputs, { locale?: "en" | "fr" | "de" | "it" | "ru" | "es" | "zh-CN" | "ja" | "hi" | "pt-PT" }, {}>} */ ((inputs = {}, options = {}) => {
	void inputs;
	const locale = experimentalStaticLocale ?? options.locale ?? getLocale()
	if (locale === "fr") return /** @type {LocalizedString} */ ("Sélection du développeur")
	if (locale === "de") return /** @type {LocalizedString} */ ("Entwicklerauswahl")
	if (locale === "it") return /** @type {LocalizedString} */ ("Selezione dello sviluppatore")
	if (locale === "ru") return /** @type {LocalizedString} */ ("Выбор разработчика")
	if (locale === "es") return /** @type {LocalizedString} */ ("Selección de desarrolladores")
	if (locale === "zh-CN") return /** @type {LocalizedString} */ ("开发商选择")
	if (locale === "ja") return /** @type {LocalizedString} */ ("開発者の選択")
	if (locale === "hi") return /** @type {LocalizedString} */ ("डेवलपर चयन")
	if (locale === "pt-PT") return /** @type {LocalizedString} */ ("Seleção do desenvolvedor")
	return /** @type {LocalizedString} */ ("Developer Selection")
});